import { FC, useEffect, useState } from 'react'

type Props = {
  startedAt?: string | null
  onContinue: () => void
  timedOut: boolean
}

// la génération v2 de Duda (AI planner) prend 1 à 2 minutes
const STAGES = [
  { afterSeconds: 0, label: 'Analyse de votre activité' },
  { afterSeconds: 20, label: 'Plan du site et rédaction des textes' },
  { afterSeconds: 55, label: 'Mise en page et choix des images' },
  { afterSeconds: 90, label: 'Dernières finitions' },
]

// écran d'attente « votre surprise se prépare » pendant la génération Duda (1 à 2 min)
const GeneratedSiteWaiting: FC<Props> = ({ startedAt, onContinue, timedOut }) => {
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    const origin = startedAt ? new Date(startedAt).getTime() : Date.now()
    const tick = () => setElapsed(Math.max(Math.floor((Date.now() - origin) / 1000), 0))
    tick()
    const interval = window.setInterval(tick, 1000)
    return () => window.clearInterval(interval)
  }, [startedAt])

  const activeIndex = STAGES.reduce((index, stage, i) => (elapsed >= stage.afterSeconds ? i : index), 0)

  return (
    <div className="rounded-[28px] bg-black text-white md:p-12 p-6 text-center animate-fade-up">
      <div className="text-[11px] uppercase tracking-[0.25em] text-white/50 mb-4">Votre surprise se prépare</div>
      <h1 className="[&&&]:text-3xl md:[&&&]:text-4xl font-aeonik font-medium text-white [&&&]:mb-3">Nous construisons quelque chose pour vous.</h1>
      <p className="text-white/70 text-sm md:text-base mb-8 max-w-[520px] mx-auto">
        Vous nous avez décrit votre activité. Une intelligence artificielle en fait, en ce moment même, un site complet. Encore une minute ou deux.
      </p>

      <ul className="text-left max-w-[360px] mx-auto space-y-3">
        {STAGES.map((stage, index) => {
          const done = index < activeIndex
          const active = index === activeIndex
          return (
            <li key={stage.label} className={`flex items-center gap-3 text-sm ${done || active ? 'text-white' : 'text-white/40'}`}>
              <span className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border ${done ? 'bg-white border-white text-black' : active ? 'border-white' : 'border-white/30'}`}>
                {done ? '✓' : active ? <span className="h-2 w-2 rounded-full bg-white animate-pulse" /> : ''}
              </span>
              {stage.label}
            </li>
          )
        })}
      </ul>

      {timedOut ? (
        <div className="mt-8">
          <p className="text-sm text-white/70 mb-4">
            C’est un peu plus long que prévu : nous vous enverrons un email dès que votre surprise sera prête, et vous la retrouverez dans votre espace client.
          </p>
          <button type="button" onClick={onContinue} className="w-full md:w-auto px-8 font-semibold bg-white text-black py-3 rounded-xl">
            Continuer mon inscription
          </button>
        </div>
      ) : (
        <button type="button" onClick={onContinue} className="mt-8 text-sm text-white/50 underline">
          Je verrai plus tard, continuer mon inscription
        </button>
      )}
    </div>
  )
}

export default GeneratedSiteWaiting
